// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605271125/js/" + chunkId + "." + {"44":"fa123fcb","225":"2cf82865","481":"6e04891c","486":"fca3071f","770":"bdb1f644"}[chunkId] + ".0.7803462354279049.chunk.js";
};